export default "<input type=\"hidden\" [formControl]=\"control\" />";